import { render, staticRenderFns } from "./ProfilePrivacy.vue?vue&type=template&id=63e27202&"
import script from "./ProfilePrivacy.vue?vue&type=script&lang=js&"
export * from "./ProfilePrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e27202')) {
      api.createRecord('63e27202', component.options)
    } else {
      api.reload('63e27202', component.options)
    }
    module.hot.accept("./ProfilePrivacy.vue?vue&type=template&id=63e27202&", function () {
      api.rerender('63e27202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/ProfilePrivacy.vue"
export default component.exports